export const FILE_UPLOAD_CONFIG = {
  documents: {
    maxSize: 50 * 1024 * 1024, // 50MB
    allowedTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/plain'
    ],
    allowedExtensions: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt']
  },
  photos: {
    maxSize: 25 * 1024 * 1024, // 25MB
    allowedTypes: [
      'image/jpeg',
      'image/jpg', 
      'image/png',
      'image/heic',
      'image/webp'
    ],
    allowedExtensions: ['.jpg', '.jpeg', '.png', '.heic', '.webp']
  }
};

export const validateFile = (file, type) => {
  const config = FILE_UPLOAD_CONFIG[type];
  
  if (!config) {
    throw new Error(`Invalid file type: ${type}`);
  }
  
  if (file.size > config.maxSize) {
    const maxSizeMB = config.maxSize / (1024 * 1024);
    throw new Error(`File size exceeds ${maxSizeMB}MB limit`);
  }
  
  if (!config.allowedTypes.includes(file.type)) {
    throw new Error(`File type ${file.type} not allowed`);
  }
  
  const extension = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
  if (!config.allowedExtensions.includes(extension)) {
    throw new Error(`File extension ${extension} not allowed`);
  }
  
  return true;
};

export const sanitizeFileName = (fileName) => {
  return fileName
    .replace(/[^a-zA-Z0-9.-]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
};

export const getFileType = (file) => {
  const extension = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
  
  if (FILE_UPLOAD_CONFIG.photos.allowedExtensions.includes(extension)) {
    return 'photos';
  } else if (FILE_UPLOAD_CONFIG.documents.allowedExtensions.includes(extension)) {
    return 'documents';
  }
  
  return null;
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};